import { FormLoja } from '@/models'
import { lerParametro, PARAMETROS_DA_LOJA, valoresIguais } from './catalogo-de-parametros'
import { CAMPOS_DE_CADASTRO, IdDaSecao } from './secoes'

export interface AlteracaoDaLoja {
	id: string
	titulo: string
	secao: IdDaSecao
}

/**
 * O que mudou desde a versão carregada, campo a campo e na ordem da tela. Comparar a loja inteira por JSON acusaria
 * mudança que ninguém fez (o campo de CNPJ formata o número ao montar, por exemplo).
 */
export function listarAlteracoes(anterior: FormLoja | null, atual: FormLoja | null): AlteracaoDaLoja[] {
	if (!anterior || !atual) return []
	const doCatalogo = PARAMETROS_DA_LOJA
		.filter(parametro => !valoresIguais(
			lerParametro(anterior.configuracaoDaLoja, parametro),
			lerParametro(atual.configuracaoDaLoja, parametro),
		))
		.map(({ id, titulo, assunto }) => ({ id, titulo, secao: assunto as IdDaSecao }))
	const doCadastro = CAMPOS_DE_CADASTRO
		.filter(campo => campo.valor && JSON.stringify(campo.valor(anterior)) !== JSON.stringify(campo.valor(atual)))
		.map(({ id, titulo, secao }) => ({ id, titulo, secao }))
	return [...doCadastro, ...doCatalogo]
}
